import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, ArrowRight, Check } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  const checkoutUrl = 'https://checkout.ebookbtnlines.shop/cart/45383723909167:1';
  return <section id="comprar" className="py-24 px-4 relative" data-id="element-100">
      <div className="max-w-4xl mx-auto" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border-2 border-brand-accent/50 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(180,255,0,0.15)] relative overflow-hidden" data-id="element-102">
          {/* Ribbon */}
          <div className="absolute top-6 -right-12 bg-brand-accent text-brand-dark font-bold py-1 px-12 transform rotate-45 text-sm uppercase tracking-wider shadow-lg" data-id="element-103">
            Oferta Especial
          </div>

          <div className="text-center mb-10" data-id="element-104">
            <h2 className="text-3xl md:text-5xl font-display text-brand-cream mb-4 uppercase" data-id="element-105">
              Resumen de tu pedido
            </h2>
            <p className="text-brand-cream/80" data-id="element-106">
              Acceso inmediato y de por vida a todo el material.
            </p>
          </div>

          <div className="bg-brand-dark/50 rounded-2xl p-6 mb-8 border border-brand-mint/10" data-id="element-107">
            <ul className="space-y-4" data-id="element-108">
              {['Guía Completa Hockey Infantil 360°', 'BONO: Plantillas Imprimibles', 'BONO: Calendario Anual', 'BONO: 50 Juegos Extra', 'Actualizaciones futuras gratis'].map((item, i) => <li key={i} className="flex items-center gap-3 text-brand-cream" data-id="element-109">
                  <Check className="w-5 h-5 text-brand-mint flex-shrink-0" data-id="element-110" />
                  <span className="font-medium" data-id="element-111">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="mb-10" data-id="element-112">
            <CountdownTimer data-id="element-113" />
          </div>

          <div className="text-center mb-8" data-id="element-114">
            <p className="text-brand-cream/60 text-lg mb-2" data-id="element-115">
              Precio Normal: <span className="line-through" data-id="element-116">$49.990</span>
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-117">
              <span className="text-6xl md:text-7xl font-display text-brand-accent drop-shadow-lg" data-id="element-118">
                $19.990
              </span>
              <span className="text-brand-cream/80 text-sm font-bold uppercase text-left leading-tight" data-id="element-119">
                Pesos
                <br data-id="element-120" />
                Argentinos
              </span>
            </div>
            <p className="text-brand-mint text-sm mt-2 font-medium" data-id="element-121">
              Único pago. Acceso de por vida.
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-122">
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full max-w-md group relative inline-flex items-center justify-center gap-3 px-8 py-6 bg-brand-accent hover:bg-brand-accentHover text-brand-dark font-display text-2xl md:text-3xl uppercase tracking-wider rounded-xl shadow-[0_0_40px_rgba(180,255,0,0.4)] transition-all hover:scale-105 hover:shadow-[0_0_60px_rgba(180,255,0,0.6)]" data-id="element-123">
              COMPRAR AHORA
              <ArrowRight className="w-8 h-8 group-hover:translate-x-1 transition-transform" data-id="element-124" />
            </a>

            <div className="flex items-center gap-2 mt-6 text-brand-cream/70 text-sm" data-id="element-125">
              <ShieldCheck className="w-5 h-5 text-green-400" data-id="element-126" />
              <span data-id="element-127">Pago 100% Seguro y Encriptado</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}